import { GetterTree } from "vuex";

import { SubscriptionDescriptionsData } from "@/types";
import { RootState, SubscriptionDescriptionState } from "@/types/store/clientzone";

export const getters: GetterTree<SubscriptionDescriptionState, RootState> = {
  GET_SUBSCRIPTION_DESCRIPTIONS: (state): Array<SubscriptionDescriptionsData> => [...state.subscriptionDescriptions],
  GET_ACTIVE_SUBSCRIPTION_DESCRIPTIONS: (state): Array<SubscriptionDescriptionsData> => JSON.parse(JSON.stringify(state.subscriptionDescriptions.filter(subscriptionDescription => subscriptionDescription.deletedAt == null)))
}
